import get from 'lodash-es/get'
import * as React from 'react'

import { IItemCard } from '../interface'

import LockupAddToCartButton from '../lockupAddToCartButton'
import LockupLastUpdated from '../lockupLastUpdated'
import LockupActionPanel from '../lockupListActionPanel'
import LockupPreviewButton from '../lockupPreviewButton'
import LockupPrice from '../lockupPrice'
import LockupRating from '../lockupRating'
import LockupSales from '../lockupSales'

import * as styles from './itemCardSidebar.module.css'

const ItemCardSidebar = (props: IItemCard) => {
  const hasPreview = get(props, 'item.previews.live_site')
  const buttons = hasPreview ? (
    <React.Fragment>
      <LockupPreviewButton {...props} />
      <LockupAddToCartButton icon {...props} />
    </React.Fragment>
  ) : (
    <LockupAddToCartButton {...props} />
  )

  return (
    <section className={styles.root}>
      <section className={styles.actionPanel}>
        <LockupActionPanel {...props} />
      </section>
      <section className={styles.itemMeta}>
        <LockupPrice
          originalPriceInCents={props.item.original_price_cents}
          priceInCents={props.item.price_cents}
        />
        <LockupRating {...props} />
        <LockupSales {...props} />
        <LockupLastUpdated {...props} />
      </section>
      <section className={styles.cartButtons}>{buttons}</section>
    </section>
  )
}

export default ItemCardSidebar
